<div class="tw-w-full overflow-scroll">
    <div class="tw-flex tw-w-full tw-justify-between">
        <div class="tw-flex tw-items-center">
            <button
                class="m-1"
                mat-icon-button
                color="warn"
                (click)="close()">
                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
            </button>
            @if (!isTemplate) {
                <app-ecmr-status
                    [status]="
                        ecmr ? ecmr.ecmrStatus : EcmrStatus.NEW
                    "></app-ecmr-status>
            }
        </div>
        <div class="tw-flex tw-items-center">
            @if (!isTemplate) {
                <button
                    class="m-1 me-2"
                    mat-stroked-button
                    [matMenuTriggerFor]="documentsMenu"
                    [matBadge]="documents.length"
                    matBadgeColor="accent"
                    [matBadgeHidden]="documents.length === 0">
                    {{ 'ECMR.quick_view_buttons.documents' | translate }}
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        iconPositionEnd
                        >attach_file
                    </mat-icon>
                </button>
                <mat-menu #documentsMenu="matMenu">
                    @if (documents.length === 0) {
                        <div
                            mat-menu-item
                            disabled>
                            {{
                                'ECMR.ecmr_editor.documents.no_documents'
                                    | translate
                            }}
                        </div>
                    }
                    @for (doc of documents; track doc.id) {
                        <button
                            mat-menu-item
                            (click)="downloadDocument(doc)"
                            matTooltip="Download">
                            <mat-icon fontSet="material-symbols-outlined"
                                >{{ getFileIcon(doc.mimeType) }}
                            </mat-icon>
                            <span>{{ doc.fileName }}</span>
                        </button>
                    }
                </mat-menu>
            }
            @if (!isTemplate && !isArchive) {
                <button
                    class="m-1"
                    mat-flat-button
                    color="primary"
                    [disabled]="isReadOnly"
                    (click)="moveToArchive()">
                    {{ 'ECMR.quick_view_buttons.archive' | translate }}
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        iconPositionEnd
                        >archive
                    </mat-icon>
                </button>
            }
            @if (isArchive) {
                <button
                    class="m-1"
                    mat-flat-button
                    color="primary"
                    [disabled]="isReadOnly"
                    (click)="reactivateFromArchive()">
                    {{ 'ECMR.quick_view_buttons.remove_archive' | translate }}
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        iconPositionEnd
                        >archive
                    </mat-icon>
                </button>
            }
            @if (!isTemplate) {
                <button
                    class="m-1"
                    mat-flat-button
                    color="primary"
                    (click)="
                        ecmrActionsService.downloadPdf(
                            ecmr.ecmrId!,
                            null,
                            null,
                            ecmr.ecmrConsignment.referenceIdentificationNumber
                                .value!,
                            dcaCompliant
                        )
                    ">
                    {{ 'ECMR.quick_view_buttons.pdf' | translate }}
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        iconPositionEnd
                        >picture_as_pdf
                    </mat-icon>
                </button>
            }
            @if (!isArchive) {
                <button
                    class="m-1"
                    mat-flat-button
                    color="primary"
                    [disabled]="
                        ecmr.ecmrStatus === EcmrStatus.DELIVERED || isReadOnly
                    "
                    (click)="editEcmr()">
                    {{ 'ECMR.quick_view_buttons.edit' | translate }}
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        iconPositionEnd
                        >edit_note
                    </mat-icon>
                </button>
            }
            @if (!isTemplate && !isArchive) {
                <button
                    class="m-1"
                    mat-stroked-button
                    (click)="shareEcmr()"
                    [disabled]="isShareButtonDisabled || isReadOnly">
                    {{ 'ECMR.quick_view_buttons.share' | translate }}
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        iconPositionEnd
                        >share
                    </mat-icon>
                </button>
            }
            @if (!isTemplate && !isArchive) {
                <button
                    class="m-1"
                    mat-stroked-button
                    (click)="showHistoryOfEcmr()">
                    {{ 'ECMR.quick_view_buttons.history' | translate }}
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        iconPositionEnd
                        >history
                    </mat-icon>
                </button>
            }
        </div>
    </div>

    <div class="overflow-y-auto quick-info-container overflow-x-auto">
        <mat-card class="m-4 position-sticky top-0 z-3">
            <mat-card-content class="d-flex flex-row align-items-center gap-4">
                <div class="ecmr-cmr-logo">
                    <div>CMR</div>
                </div>
                <div class="d-flex flex-column gap-1">
                    <div>
                        <div class="header-info-label">eCMR ID</div>
                        <div>{{ ecmr.ecmrId }}</div>
                    </div>
                    <div>
                        <div class="header-info-label">
                            {{ 'ECMR.ecmr_editor.reference_id' | translate }}
                        </div>
                        <div>
                            {{
                                ecmr.ecmrConsignment
                                    .referenceIdentificationNumber.value
                            }}
                        </div>
                    </div>
                </div>
            </mat-card-content>
            @if (dcaCompliant) {
                <div class="header-info-label px-3 pb-2 mt-2">
                    {{ 'ECMR.ecmr_editor.dca_compliance' | translate }}
                </div>
            }
        </mat-card>
        <mat-card class="m-4">
            <mat-card-content class="d-flex flex-column">
                <h6 class="fw-bold mb-2">
                    {{ 'ECMR.ecmr_editor.title_1' | translate }}
                </h6>
                <!-- Sender -->
                <!--Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.sender.name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.senderInformation.senderCompanyName
                    ">
                </app-ecmr-display-information-field>

                <!--Person Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.sender.person_name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.senderInformation.senderPersonName
                    ">
                </app-ecmr-display-information-field>

                <!--Street Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.sender.street_name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.senderInformation.senderStreet
                    ">
                </app-ecmr-display-information-field>

                <div class="row">
                    <!--Post Code-->
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.sender.post_code'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.senderInformation
                                .senderPostcode
                        ">
                    </app-ecmr-display-information-field>
                    <!--City Name-->
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.sender.city_name'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.senderInformation.senderCity
                        ">
                    </app-ecmr-display-information-field>
                </div>

                <!-- Country -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.sender.country'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.senderInformation.senderCountryCode
                            .value
                    ">
                </app-ecmr-display-information-field>

                <!-- Tax Number -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.sender.tax_number'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.senderInformation.taxNumber
                    ">
                </app-ecmr-display-information-field>

                <!-- Email -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.sender.email'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.senderInformation
                            .senderContactInformation.email
                    ">
                </app-ecmr-display-information-field>
                <!-- Phone -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.sender.phone'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.senderInformation
                            .senderContactInformation.phone
                    ">
                </app-ecmr-display-information-field>

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_2' | translate }}
                </h6>
                <!-- Consignee -->
                @if (
                    !ecmr.ecmrConsignment.multiConsigneeShipment
                        .isMultiConsigneeShipment
                ) {
                    <div>
                        <!--Name-->
                        <app-ecmr-display-information-field
                            [label]="'ECMR.ecmr_editor.consignee.name'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.consigneeInformation
                                    .consigneeCompanyName
                            ">
                        </app-ecmr-display-information-field>
                        <!--Person Name-->
                        <app-ecmr-display-information-field
                            [label]="'ECMR.ecmr_editor.consignee.person_name'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.consigneeInformation
                                    .consigneePersonName
                            ">
                        </app-ecmr-display-information-field>
                        <!--Street Name-->
                        <app-ecmr-display-information-field
                            [label]="'ECMR.ecmr_editor.consignee.street_name'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.consigneeInformation
                                    .consigneeStreet
                            ">
                        </app-ecmr-display-information-field>
                        <div class="row">
                            <!--Post Code-->
                            <app-ecmr-display-information-field
                                class="col"
                                [label]="'ECMR.ecmr_editor.consignee.post_code'"
                                [displayedContent]="
                                    ecmr.ecmrConsignment.consigneeInformation
                                        .consigneePostcode
                                ">
                            </app-ecmr-display-information-field>
                            <!--City Name-->
                            <app-ecmr-display-information-field
                                class="col"
                                [label]="'ECMR.ecmr_editor.consignee.city_name'"
                                [displayedContent]="
                                    ecmr.ecmrConsignment.consigneeInformation
                                        .consigneeCity
                                ">
                            </app-ecmr-display-information-field>
                        </div>
                        <!-- Country -->
                        <app-ecmr-display-information-field
                            [label]="'ECMR.ecmr_editor.consignee.country'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.consigneeInformation
                                    .consigneeCountryCode.value
                            ">
                        </app-ecmr-display-information-field>
                        <!-- Email -->
                        <app-ecmr-display-information-field
                            [label]="'ECMR.ecmr_editor.consignee.email'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.consigneeInformation
                                    .consigneeContactInformation.email
                            ">
                        </app-ecmr-display-information-field>
                        <!-- Phone -->
                        <app-ecmr-display-information-field
                            [label]="'ECMR.ecmr_editor.consignee.phone'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.consigneeInformation
                                    .consigneeContactInformation.phone
                            ">
                        </app-ecmr-display-information-field>
                    </div>
                }
                @if (
                    ecmr.ecmrConsignment.multiConsigneeShipment
                        .isMultiConsigneeShipment
                ) {
                    <div>
                        {{
                            'ECMR.ecmr_editor.multi_consignee_shipment.multi_consignee_shipment_notice'
                                | translate
                        }}
                    </div>
                }

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_3' | translate }}
                </h6>
                <!-- Taking over the goods -->
                <!-- Place -->
                <span class="info-field-header">{{
                    'ECMR.ecmr_editor.taking_over_the_goods.place' | translate
                }}</span>
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.taking_over_the_goods.place'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.takingOverTheGoods
                            .takingOverTheGoodsPlace
                    ">
                </app-ecmr-display-information-field>

                <div class="row">
                    <div class="col">
                        <app-ecmr-display-information-field
                            [label]="'ECMR.ecmr_editor.taking_over_the_goods.time_of_arrival'"
                            [displayedContent]="
                                toDateString(
                                    ecmr.ecmrConsignment.takingOverTheGoods
                                        .logisticsTimeOfArrivalDateTime
                                )
                            ">
                        </app-ecmr-display-information-field>
                    </div>
                    <div class="col">
                        <app-ecmr-display-information-field
                            [label]="'ECMR.ecmr_editor.taking_over_the_goods.time_of_departure'"
                            [displayedContent]="
                                toDateString(
                                    ecmr.ecmrConsignment.takingOverTheGoods
                                        .logisticsTimeOfDepartureDateTime
                                )
                            ">
                        </app-ecmr-display-information-field>
                    </div>
                </div>
                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_4' | translate }}
                </h6>
                <!-- Delivery of the goods -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.delivery_of_the_goods.place'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.deliveryOfTheGoods
                            .logisticsLocationCity
                    ">
                </app-ecmr-display-information-field>

                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.delivery_of_the_goods.opening_hours'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.deliveryOfTheGoods
                            .logisticsLocationOpeningHours
                    ">
                </app-ecmr-display-information-field>

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_5' | translate }}
                </h6>

                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.senders_instruction.description'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.sendersInstructions
                            .transportInstructionsDescription
                    ">
                </app-ecmr-display-information-field>

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_6' | translate }}
                </h6>

                <!--Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation
                            .carrierCompanyName
                    ">
                </app-ecmr-display-information-field>

                <!--Person Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.person_name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation
                            .carrierDriverName
                    ">
                </app-ecmr-display-information-field>

                <!--Street Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.street_name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation.carrierStreet
                    ">
                </app-ecmr-display-information-field>

                <div class="row">
                    <!--Post Code-->
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.carrier_information.post_code'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.carrierInformation
                                .carrierPostcode
                        ">
                    </app-ecmr-display-information-field>
                    <!--City Name-->
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.carrier_information.city_name'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.carrierInformation.carrierCity
                        ">
                    </app-ecmr-display-information-field>
                </div>
                <!-- Country -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.country'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation
                            .carrierCountryCode.value
                    ">
                </app-ecmr-display-information-field>

                <!-- Tax Number -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.tax_number'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation.taxNumber
                    ">
                </app-ecmr-display-information-field>

                <!-- License Plate (derived: latest motor plate)-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.license_plate'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation
                            .vehicleConfigurationHistory | latestMotorPlate
                    ">
                </app-ecmr-display-information-field>

                <!-- Vehicle Configuration History -->
                @if (
                    ecmr.ecmrConsignment.carrierInformation
                        .vehicleConfigurationHistory?.length
                ) {
                    <h6 class="fw-bold mb-2 mt-4">
                        {{
                            'ECMR.ecmr_editor.vehicle_configuration.title'
                                | translate
                        }}
                    </h6>
                    @for (
                        config of ecmr.ecmrConsignment.carrierInformation
                            .vehicleConfigurationHistory;
                        track config;
                        let index = $index
                    ) {
                        <div class="border rounded p-2 mb-2">
                            <div class="fw-bold mb-1">
                                {{
                                    'ECMR.ecmr_editor.vehicle_configuration.title'
                                        | translate
                                }}
                                {{ index + 1 }}
                            </div>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.vehicle_configuration.date'"
                                [displayedContent]="
                                    toDateString(config.timestamp)
                                ">
                            </app-ecmr-display-information-field>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.vehicle_configuration.motor_plate'"
                                [displayedContent]="
                                    config.motorVehicleLicensePlate
                                ">
                            </app-ecmr-display-information-field>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.vehicle_configuration.trailer_plate'"
                                [displayedContent]="config.trailerLicensePlate">
                            </app-ecmr-display-information-field>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.vehicle_configuration.second_trailer_plate'"
                                [displayedContent]="
                                    config.secondTrailerLicensePlate
                                ">
                            </app-ecmr-display-information-field>
                        </div>
                    }
                }

                <!-- Email -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.email'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation
                            .carrierContactInformation.email
                    ">
                </app-ecmr-display-information-field>
                <!-- Phone -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.phone'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation
                            .carrierContactInformation.carrierPhone
                    ">
                </app-ecmr-display-information-field>

                <!-- Driver Phone -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.carrier_information.driver_phone'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.carrierInformation
                            .carrierContactInformation.driverPhone
                    ">
                </app-ecmr-display-information-field>

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_7' | translate }}
                </h6>
                <!--Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.successive_carrier_information.name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.successiveCarrierInformation
                            .successiveCarrierCompanyName
                    ">
                </app-ecmr-display-information-field>

                <!--Person Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.successive_carrier_information.person_name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.successiveCarrierInformation
                            .successiveCarrierDriverName
                    ">
                </app-ecmr-display-information-field>

                <!--Street Name-->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.successive_carrier_information.street_name'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.successiveCarrierInformation
                            .successiveCarrierStreet
                    ">
                </app-ecmr-display-information-field>

                <div class="row">
                    <!--Post Code-->
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.successive_carrier_information.post_code'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.successiveCarrierInformation
                                .successiveCarrierPostcode
                        ">
                    </app-ecmr-display-information-field>
                    <!--City Name-->
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.successive_carrier_information.city_name'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.successiveCarrierInformation
                                .successiveCarrierCity
                        ">
                    </app-ecmr-display-information-field>
                </div>
                <!-- Country -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.successive_carrier_information.country'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.successiveCarrierInformation
                            .successiveCarrierCountryCode.value
                    ">
                </app-ecmr-display-information-field>

                <!-- Tax Number -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.successive_carrier_information.tax_number'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.successiveCarrierInformation
                            .taxNumber
                    ">
                </app-ecmr-display-information-field>

                <!-- Vehicle Configuration History -->
                @if (
                    ecmr.ecmrConsignment.successiveCarrierInformation
                        .vehicleConfigurationHistory?.length
                ) {
                    <h6 class="fw-bold mb-2 mt-4">
                        {{
                            'ECMR.ecmr_editor.vehicle_configuration.title'
                                | translate
                        }}
                    </h6>
                    @for (
                        config of ecmr.ecmrConsignment
                            .successiveCarrierInformation
                            .vehicleConfigurationHistory;
                        track config;
                        let index = $index
                    ) {
                        <div class="border rounded p-2 mb-2">
                            <div class="fw-bold mb-1">
                                {{
                                    'ECMR.ecmr_editor.vehicle_configuration.title'
                                        | translate
                                }}
                                {{ index + 1 }}
                            </div>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.vehicle_configuration.date'"
                                [displayedContent]="
                                    toDateString(config.timestamp)
                                ">
                            </app-ecmr-display-information-field>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.vehicle_configuration.motor_plate'"
                                [displayedContent]="
                                    config.motorVehicleLicensePlate
                                ">
                            </app-ecmr-display-information-field>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.vehicle_configuration.trailer_plate'"
                                [displayedContent]="config.trailerLicensePlate">
                            </app-ecmr-display-information-field>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.vehicle_configuration.second_trailer_plate'"
                                [displayedContent]="
                                    config.secondTrailerLicensePlate
                                ">
                            </app-ecmr-display-information-field>
                        </div>
                    }
                }

                <!-- Email -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.successive_carrier_information.email'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.successiveCarrierInformation
                            .successiveCarrierContactInformation.email
                    ">
                </app-ecmr-display-information-field>
                <!-- Phone -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.successive_carrier_information.phone'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.successiveCarrierInformation
                            .successiveCarrierContactInformation.carrierPhone
                    ">
                </app-ecmr-display-information-field>

                <!-- Driver Phone -->
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.successive_carrier_information.driver_phone'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.successiveCarrierInformation
                            .successiveCarrierContactInformation.driverPhone
                    ">
                </app-ecmr-display-information-field>
                @if (!isTemplate) {
                    <h6 class="fw-bold mb-2 mt-5">
                        {{ 'ECMR.ecmr_editor.title_8' | translate }}
                    </h6>
                    <app-ecmr-display-information-field
                        [label]="'ECMR.ecmr_editor.carriers_reservations.reservation_and_observation'"
                        [displayedContent]="
                            ecmr.ecmrConsignment
                                .carriersReservationsAndObservationsOnTakingOverTheGoods
                                .carrierReservationsObservations
                        ">
                    </app-ecmr-display-information-field>
                }
                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_9' | translate }}
                </h6>
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.documents_handed_to_carrier.remarks'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.documentsHandedToCarrier
                            .documentsRemarks
                    ">
                </app-ecmr-display-information-field>

                @if (!isTemplate) {
                    <h6 class="fw-bold mb-2 mt-5">
                        {{ 'ECMR.ecmr_editor.items' | translate }}
                    </h6>
                    <mat-accordion>
                        @for (
                            item of ecmr.ecmrConsignment.itemList;
                            track item;
                            let index = $index
                        ) {
                            <mat-expansion-panel class="exp-panel">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{
                                            'ECMR.ecmr_editor.item' | translate
                                        }}
                                        {{
                                            index +
                                                1 +
                                                ' - ' +
                                                item.numberOfPackages
                                                    .logisticsPackageItemQuantity +
                                                ' x ' +
                                                item.marksAndNos
                                                    .logisticsShippingMarksMarking
                                        }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <h6 class="fw-bold mb-2 mt-2">
                                    {{
                                        'ECMR.ecmr_editor.title_10' | translate
                                    }}
                                </h6>
                                <app-ecmr-display-information-field
                                    [label]="'ECMR.ecmr_editor.marks_and_nos.marking_text'"
                                    [displayedContent]="
                                        item.marksAndNos
                                            .logisticsShippingMarksMarking
                                    ">
                                </app-ecmr-display-information-field>
                                <h6 class="fw-bold mb-2 mt-0">
                                    {{
                                        'ECMR.ecmr_editor.marks_and_nos.barcode_number'
                                            | translate
                                    }}
                                </h6>
                                <mat-chip-set>
                                    @for (
                                        barcode of item.marksAndNos
                                            .logisticsShippingMarksCustomBarcodeList;
                                        track barcode.barcode
                                    ) {
                                        <mat-chip
                                            >{{ barcode.barcode }}
                                        </mat-chip>
                                    }
                                </mat-chip-set>

                                <h6 class="fw-bold mb-2 mt-2">
                                    {{
                                        'ECMR.ecmr_editor.title_11' | translate
                                    }}
                                </h6>
                                <app-ecmr-display-information-field
                                    [label]="'ECMR.ecmr_editor.number_of_packages.item_quantity'"
                                    [displayedContent]="
                                        item.numberOfPackages
                                            .logisticsPackageItemQuantity
                                    ">
                                </app-ecmr-display-information-field>

                                <h6 class="fw-bold mb-2 mt-2">
                                    {{
                                        'ECMR.ecmr_editor.title_12' | translate
                                    }}
                                </h6>
                                <app-ecmr-display-information-field
                                    [label]="'ECMR.ecmr_editor.method_of_packing.type_text'"
                                    [displayedContent]="
                                        item.methodOfPacking
                                            .logisticsPackageType
                                    ">
                                </app-ecmr-display-information-field>

                                <h6 class="fw-bold mb-2 mt-2">
                                    {{
                                        'ECMR.ecmr_editor.title_13' | translate
                                    }}
                                </h6>
                                <app-ecmr-display-information-field
                                    [label]="'ECMR.ecmr_editor.nature_of_goods.identification_text'"
                                    [displayedContent]="
                                        item.natureOfTheGoods
                                            .transportCargoIdentification
                                    ">
                                </app-ecmr-display-information-field>

                                <div class="row">
                                    <div class="col">
                                        <h6 class="fw-bold mb-2 mt-2">
                                            {{
                                                'ECMR.ecmr_editor.title_14'
                                                    | translate
                                            }}
                                        </h6>
                                        <app-ecmr-display-information-field
                                            [label]="'ECMR.ecmr_editor.gross_weight_in_kg.gross_weight'"
                                            [displayedContent]="
                                                item.grossWeightInKg
                                                    .supplyChainConsignmentItemGrossWeight
                                            ">
                                        </app-ecmr-display-information-field>
                                    </div>
                                    <div class="col">
                                        <h6 class="fw-bold mb-2 mt-2">
                                            {{
                                                'ECMR.ecmr_editor.title_15'
                                                    | translate
                                            }}
                                        </h6>
                                        <app-ecmr-display-information-field
                                            [label]="'ECMR.ecmr_editor.volume_in_m3.volume'"
                                            [displayedContent]="
                                                item.volumeInM3
                                                    .supplyChainConsignmentItemGrossVolume
                                            ">
                                        </app-ecmr-display-information-field>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        }
                    </mat-accordion>
                }

                @if (
                    !isTemplate && ecmr.ecmrConsignment.specialPermits?.length
                ) {
                    <h6 class="fw-bold mb-2 mt-5">
                        {{
                            'ECMR.ecmr_editor.special_permits.title' | translate
                        }}
                    </h6>
                    @for (
                        permit of ecmr.ecmrConsignment.specialPermits;
                        track permit;
                        let index = $index
                    ) {
                        <div class="border rounded p-2 mb-2">
                            <div class="fw-bold mb-1">
                                {{
                                    'ECMR.ecmr_editor.special_permits.title'
                                        | translate
                                }}
                                {{ index + 1 }}
                            </div>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.special_permits.type'"
                                [displayedContent]="permit.type">
                            </app-ecmr-display-information-field>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.special_permits.reference'"
                                [displayedContent]="permit.reference">
                            </app-ecmr-display-information-field>
                            <app-ecmr-display-information-field
                                [label]="'ECMR.ecmr_editor.special_permits.description'"
                                [displayedContent]="permit.description">
                            </app-ecmr-display-information-field>
                        </div>
                    }
                }

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_16' | translate }}
                </h6>
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.special_agreements_sen_carr.special_agreements'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.specialAgreementsSenderCarrier
                            .customSpecialAgreement
                    ">
                </app-ecmr-display-information-field>

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_17' | translate }}
                </h6>
                <div class="row">
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.carriage_charges'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy.customChargeCarriage
                                .value
                        ">
                    </app-ecmr-display-information-field>
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.currency'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy.customChargeCarriage
                                .currency
                        ">
                    </app-ecmr-display-information-field>
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.payer'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy.customChargeCarriage
                                .payer
                        ">
                    </app-ecmr-display-information-field>
                </div>
                <div class="row">
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.supplementary_charges'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy
                                .customChargeSupplementary.value
                        ">
                    </app-ecmr-display-information-field>
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.currency'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy
                                .customChargeSupplementary.currency
                        ">
                    </app-ecmr-display-information-field>
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.payer'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy
                                .customChargeSupplementary.payer
                        ">
                    </app-ecmr-display-information-field>
                </div>
                <div class="row">
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.custom_duties_charges'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy
                                .customChargeCustomsDuties.value
                        ">
                    </app-ecmr-display-information-field>
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.currency'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy
                                .customChargeCustomsDuties.currency
                        ">
                    </app-ecmr-display-information-field>
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.payer'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy
                                .customChargeCustomsDuties.payer
                        ">
                    </app-ecmr-display-information-field>
                </div>
                <div class="row">
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.other_charges'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy.customChargeOther
                                .value
                        ">
                    </app-ecmr-display-information-field>
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.currency'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy.customChargeOther
                                .currency
                        ">
                    </app-ecmr-display-information-field>
                    <app-ecmr-display-information-field
                        class="col"
                        [label]="'ECMR.ecmr_editor.to_be_paid_by.payer'"
                        [displayedContent]="
                            ecmr.ecmrConsignment.toBePaidBy.customChargeOther
                                .payer
                        ">
                    </app-ecmr-display-information-field>
                </div>

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_18' | translate }}
                </h6>
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.other_useful_particulars.particulars'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.otherUsefulParticulars
                            .customParticulars
                    ">
                </app-ecmr-display-information-field>

                <h6 class="fw-bold mb-2 mt-5">
                    {{ 'ECMR.ecmr_editor.title_19' | translate }}
                </h6>
                <app-ecmr-display-information-field
                    [label]="'ECMR.ecmr_editor.cash_on_delivery.title'"
                    [displayedContent]="
                        ecmr.ecmrConsignment.cashOnDelivery.customCashOnDelivery
                    ">
                </app-ecmr-display-information-field>

                @if (
                    getTransportType(ecmr) === EcmrTransportType.International
                ) {
                    <h6 class="fw-bold mb-2 mt-5">
                        {{ 'ECMR.ecmr_editor.title_20' | translate }}
                    </h6>
                }

                @if (!isTemplate) {
                    <h6 class="fw-bold mb-2 mt-5">
                        {{ 'ECMR.ecmr_editor.title_21' | translate }}
                    </h6>
                    <div class="row">
                        <app-ecmr-display-information-field
                            class="col"
                            [label]="'ECMR.ecmr_editor.established.in'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.established
                                    .customEstablishedIn
                            ">
                        </app-ecmr-display-information-field>
                        <app-ecmr-display-information-field
                            class="col"
                            [label]="'ECMR.ecmr_editor.established.on'"
                            [displayedContent]="
                                toDateString(
                                    ecmr.ecmrConsignment.established
                                        .customEstablishedDate
                                )
                            ">
                        </app-ecmr-display-information-field>
                    </div>

                    <h6 class="fw-bold mb-2 mt-5">
                        {{ 'ECMR.ecmr_editor.title_22' | translate }}
                    </h6>
                    <span class="info-field-header">{{
                        'ECMR.ecmr_editor.sender_signature.signature'
                            | translate
                    }}</span>
                    @if (senderSealMetadata) {
                        <mat-card
                            appearance="outlined"
                            class="tw-w-1/3">
                            <mat-card-content>
                                <div
                                    class="d-flex justify-content-center align-items-center flex-column">
                                    <p>
                                        {{
                                            'ECMR.ecmr_editor.eseal_information'
                                                | translate
                                        }}
                                    </p>
                                    <span class="d-flex justify-content-center">
                                        {{
                                            'ECMR.signature.signed_on'
                                                | translate
                                        }}
                                        {{
                                            toDateString(
                                                senderSealMetadata.timestamp
                                            )
                                        }}
                                    </span>
                                    <p class="text-center">
                                        {{ 'ECMR.signature.by' | translate }}
                                        {{ senderSealMetadata.sealer }}
                                    </p>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    }
                    <h6 class="fw-bold mb-2 mt-5">
                        {{ 'ECMR.ecmr_editor.title_23' | translate }}
                    </h6>
                    <span class="info-field-header">{{
                        'ECMR.ecmr_editor.carrier_signature.signature'
                            | translate
                    }}</span>
                    @if (carrierSealMetadata) {
                        <mat-card
                            appearance="outlined"
                            class="tw-w-1/3">
                            <mat-card-content>
                                <div
                                    class="d-flex justify-content-center align-items-center flex-column">
                                    <p>
                                        {{
                                            'ECMR.ecmr_editor.eseal_information'
                                                | translate
                                        }}
                                    </p>
                                    <span class="d-flex justify-content-center">
                                        {{
                                            'ECMR.signature.signed_on'
                                                | translate
                                        }}
                                        {{
                                            toDateString(
                                                carrierSealMetadata.timestamp
                                            )
                                        }}
                                    </span>
                                    <p class="text-center">
                                        {{ 'ECMR.signature.by' | translate }}
                                        {{ carrierSealMetadata.sealer }}
                                    </p>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    }
                    <h6 class="fw-bold mb-2 mt-5">
                        {{ 'ECMR.ecmr_editor.title_24' | translate }}
                    </h6>
                    <div class="row">
                        <app-ecmr-display-information-field
                            class="col"
                            [label]="'ECMR.ecmr_editor.receival_signature.date'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.goodsReceived
                                    .consigneeSignatureDate
                            ">
                        </app-ecmr-display-information-field>
                        <app-ecmr-display-information-field
                            class="col"
                            [label]="'ECMR.ecmr_editor.receival_signature.place'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.goodsReceived
                                    .confirmedLogisticsLocationName
                            ">
                        </app-ecmr-display-information-field>
                        <app-ecmr-display-information-field
                            class="col"
                            [label]="'ECMR.ecmr_editor.receival_signature.remarks'"
                            [displayedContent]="
                                ecmr.ecmrConsignment.goodsReceived
                                    .consigneeReservationsObservations
                            ">
                        </app-ecmr-display-information-field>
                    </div>
                    <!-- Signature -->
                    <span class="info-field-header">{{
                        'ECMR.ecmr_editor.receival_signature.signature'
                            | translate
                    }}</span>
                    @if (
                        ecmr.ecmrConsignment.goodsReceived.consigneeSignature
                    ) {
                        <mat-card
                            appearance="outlined"
                            class="tw-w-1/3">
                            <mat-card-content>
                                <div
                                    class="d-flex justify-content-center align-items-center flex-column">
                                    <img
                                        [src]="
                                            ecmr.ecmrConsignment.goodsReceived
                                                .consigneeSignature.data
                                        "
                                        alt="signature"
                                        class="img-fluid" />
                                    <span class="d-flex justify-content-center">
                                        {{
                                            'ECMR.signature.signed_on'
                                                | translate
                                        }}
                                        {{
                                            toDateString(
                                                ecmr.ecmrConsignment
                                                    .goodsReceived
                                                    .consigneeSignature
                                                    .timestamp
                                            )
                                        }}
                                    </span>
                                    <p class="text-center">
                                        {{ 'ECMR.signature.by' | translate }}
                                        {{
                                            ecmr.ecmrConsignment.goodsReceived
                                                .consigneeSignature.userName
                                        }}
                                    </p>
                                    @if (consigneeSealMetadata) {
                                        <p class="mt-2">
                                            {{
                                                'ECMR.ecmr_editor.eseal_information'
                                                    | translate
                                            }}
                                        </p>
                                        <span
                                            class="d-flex justify-content-center">
                                            {{
                                                'ECMR.signature.signed_on'
                                                    | translate
                                            }}
                                            {{
                                                toDateString(
                                                    consigneeSealMetadata.timestamp
                                                )
                                            }}
                                        </span>
                                        <p class="text-center">
                                            {{
                                                'ECMR.signature.by' | translate
                                            }}
                                            {{ consigneeSealMetadata.sealer }}
                                        </p>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>
                    }

                    <h6 class="fw-bold mb-2 mt-5">
                        {{
                            'ECMR.ecmr_editor.non_contractual_part_reserved_for_the_carrier'
                                | translate
                        }}
                    </h6>
                    <app-ecmr-display-information-field
                        [label]="'ECMR.ecmr_editor.remarks'"
                        [displayedContent]="
                            ecmr.ecmrConsignment
                                .nonContractualPartReservedForTheCarrier
                                .nonContractualCarrierRemarks
                        ">
                    </app-ecmr-display-information-field>
                }
            </mat-card-content>
        </mat-card>
    </div>
</div>
